import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import logo from "./logo.svg";
import * as k from "./constants";

class Header extends Component {
  constructor(props) {
    super(props);
    this.gotoLogin = this.gotoLogin.bind(this);
    this.Logout = this.Logout.bind(this);
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  gotoLogin(event) {
    event.preventDefault();
    this.props.appProps.handleSignInState(true);
    this.props.appProps.handleForgotPassword(false);
  }

  Logout(event) {
    event.preventDefault();
    this.props.appProps.handleSignInState(true);
    this.props.appProps.handleUpdateState("", "", false);
    this.props.appProps.handleAppsState("currentScreen", k.HOME);
  }

  render() {
    return (
      <div className="header fixed-top container-fluid py-1 bg-dark text-white bg-splash">
        <div className="row">
          <div className="col">
            <h3>@sMedia</h3>
            <p>connect people</p>
          </div>

          <div className="col text-right align-self-center">
            {!this.props.appProps.state.authorized ? (
              !this.props.appProps.state.signIn ||
              this.props.appProps.state.forgotPassword ? (
                <button
                  type="button"
                  className="btn border text-white"
                  onClick={this.gotoLogin}
                >
                  Login
                </button>
              ) : (
                <div></div>
              )
            ) : (
              <div>
                <h5>Hi {this.props.appProps.state.username}</h5>
                <button
                  type="button"
                  className="btn border text-white"
                  onClick={this.Logout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
